// The browser's copy of the space weather summary (api/spaceweather.js),
// with the committed snapshot (public/data/spaceweather.json) when the API
// cannot answer: the Vite dev server has no API, and NOAA can be down.
// One request per part per page load, shared by every caller.
//
//   const data = await loadSpaceWeather('aurora' | 'sun' | 'all');
//   data.source: 'live' | 'snapshot'

const pending = new Map();

async function getJson(url) {
  const res = await fetch(url, { cache: 'no-cache' });
  if (!res.ok) throw new Error(`${url}: ${res.status}`);
  const type = res.headers.get('content-type') || '';
  if (!type.includes('json')) throw new Error(`${url}: not JSON`);
  return res.json();
}

export function loadSpaceWeather(part = 'all') {
  if (pending.has(part)) return pending.get(part);
  const q = part === 'all' ? '' : `?part=${part}`;
  const p = getJson(`/api/spaceweather${q}`)
    .then((d) => ({ ...d, source: d.snapshot ? 'snapshot' : 'live' }))
    .catch(() => getJson('/data/spaceweather.json').then((d) => ({ ...d, source: 'snapshot' })))
    .catch(() => null);
  pending.set(part, p);
  return p;
}

// Drop the cached answer so the next call fetches again (a page left open).
export function refreshSpaceWeather(part = 'all') {
  pending.delete(part);
  return loadSpaceWeather(part);
}
